(() => {
  const moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}";
  const CART_REQUEST_TIMEOUT = 8000;
  window.ZenTheme = window.ZenTheme || {};
  window.ZenTheme.formatMoney = function(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat.replace("${{amount}}", value).replace("${{ amount }}", value);
  };
  window.ZenTheme.updateCartCount = function(count) {
    const value = String(Number(count || 0));
    document.querySelectorAll(".zen-site-header__cart-count, .cart-count-badge, #cart-count").forEach((badge) => {
      badge.textContent = value;
      badge.classList.toggle("hidden", value === "0");
      if (value !== "0") badge.classList.add("flex");
    });
  };
  async function requestJson(url, options, timeoutMs) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs || CART_REQUEST_TIMEOUT);

    try {
      const response = await fetch(url, Object.assign({}, options || {}, { signal: controller.signal }));
      let json = null;

      try {
        json = await response.json();
      } catch (error) {
        json = null;
      }

      if (!response.ok) {
        const message = json && (json.description || json.message || json.status);
        throw new Error(message || "Cart request failed");
      }

      return json;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function createFallbackCartFromAdd(addResult, requestedQuantity) {
    const lines = Array.isArray(addResult && addResult.items)
      ? addResult.items
      : addResult
        ? [addResult]
        : [];
    const itemCount = lines.reduce((sum, line) => sum + Number(line.quantity || 0), 0) || Number(requestedQuantity || 1);

    return {
      item_count: itemCount,
      total_price: lines.reduce((sum, line) => {
        return sum + Number(line.final_line_price || line.line_price || line.price || 0);
      }, 0),
      items: lines
    };
  }

  window.ZenTheme.fetchCart = async function() {
    return requestJson("/cart.js", {
      headers: { "Accept": "application/json" }
    });
  };

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!form.matches("[data-zen-product-form]")) return;
    if (event.defaultPrevented || form.hasAttribute("data-zen-skip-ajax")) return;
    if (!window.fetch) return;
    event.preventDefault();
    const button = form.querySelector("[type='submit']");
    const original = button ? button.innerHTML : "";
    let shouldRestore = true;
    if (button) {
      button.disabled = true;
      button.innerHTML = "Adding...";
    }
    try {
      const formData = new FormData(form);
      const requestedQuantity = formData.get("quantity") || 1;
      const addResult = await requestJson("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      });
      let cart;
      try {
        cart = await window.ZenTheme.fetchCart();
      } catch (error) {
        cart = createFallbackCartFromAdd(addResult, requestedQuantity);
      }
      window.ZenTheme.updateCartCount(cart.item_count);
      if (button) button.innerHTML = "Added";
      document.dispatchEvent(new CustomEvent("zen:cart:updated", { detail: { cart } }));
    } catch (error) {
      if (button) button.innerHTML = "Try again";
      form.setAttribute("data-error", "true");
    } finally {
      setTimeout(() => {
        if (shouldRestore && button) {
          button.disabled = false;
          button.innerHTML = original;
        }
      }, 1200);
    }
  });
})();
